import type { JSX } from 'react';

import { withPrefetchedData } from 'src/shared/prefetch';

import { TermsOfServiceBanner } from '../components/TermsOfServiceBanner';
import { useBanner } from '../hooks/banner';

export const BannerSwitchContainer = withPrefetchedData(
	function BannerSwitchContainer(): JSX.Element | null {
		const banner = useBanner();

		switch (banner?.type) {
			case 'tos':
				return (
					<TermsOfServiceBanner
						onDismiss={banner.dismiss}
						onView={banner.handleView}
						onLinkClick={banner.trackLinkClick}
						copy={banner.copy}
					/>
				);
			default:
				return null;
		}
	},
	{
		prefetchName: __MODULE_HASH__,
		// the ToS banner is not prefetched anymore following a refactor of FCM retrieval
		// we could consider adding it back later if needed
		prefetchDependencies: [],
	},
);
